export default "__VITE_ASSET__c837f150__"